import React from "react";
import { ROLE_PRESETS } from "../../../utils/rolePresets";

const MODULE_LABELS = {
  home: "Home",
  jobOpenings: "Job Openings",
  departments: "Departments",
  employees: "Employees",
  trainees: "Trainees",
  attendance: "Attendance",
  leads: "Leads",
  clients: "Clients",
  proposals: "Proposals",
  invoices: "Invoices",
  reports: "Reports",
  projects: "Projects",
  users: "User Management",
  salaries: "Salaries",
  noticeBoard: "Notice Board",
  company: "Company Settings",
  tasks: "Tasks",
};

const ACTIONS = ["Add", "Edit", "View", "Delete"];

export default function PermissionSelector({ permissions, setPermissions, role }) {
  let allowedModules = [];

  if (!role) {
    allowedModules = [];
  } else if (ROLE_PRESETS[role] === "ALL") {
    allowedModules = Object.keys(MODULE_LABELS);
  } else {
    allowedModules = ROLE_PRESETS[role] || [];
  }

  const toggle = (moduleKey, action) => {
    const current = permissions[moduleKey] || [];
    const updated = current.includes(action)
      ? current.filter((a) => a !== action)
      : [...current, action];

    setPermissions({ ...permissions, [moduleKey]: updated });
  };

  const selectAll = (moduleKey) => {
    setPermissions({ ...permissions, [moduleKey]: [...ACTIONS] });
  };

  const deselectAll = (moduleKey) => {
    const copy = { ...permissions };
    delete copy[moduleKey];
    setPermissions(copy);
  };

  return (
    <div className="card mt-3 cu-perm-card">
      <div className="card-header fw-bold cu-perm-head">Module Permissions</div>
      <div className="card-body cu-perm-body">
        {allowedModules.length === 0 && (
          <p className="text-muted cu-perm-empty">Select a role to see permissions.</p>
        )}

        {allowedModules.map((key) => (
          <div key={key} className="mb-3 border rounded p-3 cu-perm-module">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0 cu-perm-module-title">{MODULE_LABELS[key]}</h6>

              <div>
                <button
                  type="button"
                  className="btn btn-sm me-2 cu-perm-btn"
                  onClick={() => selectAll(key)}
                >
                  Select All
                </button>
                <button
                  type="button"
                  className="btn btn-sm cu-perm-btn mute"
                  onClick={() => deselectAll(key)}
                >
                  Deselect All
                </button>
              </div>
            </div>

            <div className="mt-2 d-flex flex-wrap gap-3 cu-perm-actions">
              {ACTIONS.map((a) => (
                <label key={a} className="form-check form-switch cu-switch-wrap">
                  <input
                    type="checkbox"
                    className="form-check-input cu-switch"
                    checked={permissions[key]?.includes(a) || false}
                    onChange={() => toggle(key, a)}
                  />
                  <span className="ms-2 cu-switch-label">{a}</span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
